import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import NavHeader from "./NavHeader";
import "./claim-form.scss";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";
import { statusActions } from "../../ISchema";
import { formatDefaultClaim } from "./utils";
import "react-datepicker/dist/react-datepicker.css";
import { createClaim, editClaim } from "./claimActions";
import cx from "classnames";
import QueryProvider from "./QueryProvider";

var ClaimForm = function ClaimForm(props) {
  var poliza = props.poliza,
      token = props.token,
      loadedClaim = props.claim,
      _props$isEdit = props.isEdit,
      isEdit = _props$isEdit === void 0 ? false : _props$isEdit;

  var _React$useState = React.useState(1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeStep = _React$useState2[0],
      setActiveStep = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isSubmitting = _React$useState4[0],
      setIsSubmitting = _React$useState4[1];

  var defaultClaim = formatDefaultClaim(loadedClaim); // Autocompletar datos del denunciante con el contratante cuando es nuevo siniestro

  var getInitialClaim = function getInitialClaim() {
    var _contratante$emails, _contratante$emails$;

    if (isEdit || loadedClaim) {
      return defaultClaim;
    } // Si es nuevo siniestro, usar datos del contratante


    var contratante = poliza === null || poliza === void 0 ? void 0 : poliza.contratante;
    return _objectSpread(_objectSpread({}, defaultClaim), {}, {
      name: (contratante === null || contratante === void 0 ? void 0 : contratante.full_name) || (contratante === null || contratante === void 0 ? void 0 : contratante.name) || "",
      email: (contratante === null || contratante === void 0 ? void 0 : contratante.email) || (contratante === null || contratante === void 0 ? void 0 : (_contratante$emails = contratante.emails) === null || _contratante$emails === void 0 ? void 0 : (_contratante$emails$ = _contratante$emails[0]) === null || _contratante$emails$ === void 0 ? void 0 : _contratante$emails$.email) || "",
      phone: (contratante === null || contratante === void 0 ? void 0 : contratante.phone) || "",
      claimant_rut: (contratante === null || contratante === void 0 ? void 0 : contratante.rut) || ""
    });
  };

  var _React$useState5 = React.useState(getInitialClaim()),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      claim = _React$useState6[0],
      setClaim = _React$useState6[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response, _response2, _response2$payload, _response3;

      var submitClaim, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              submitClaim = _objectSpread(_objectSpread({}, claim), {}, {
                poliza_id: poliza.id
              });

              if (!isEdit) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return editClaim(loadedClaim.id, submitClaim, token);

            case 5:
              response = _context.sent;
              _context.next = 11;
              break;

            case 8:
              _context.next = 10;
              return createClaim(submitClaim, token);

            case 10:
              response = _context.sent;

            case 11:
              if (!(((_response = response) === null || _response === void 0 ? void 0 : _response.status) === statusActions.ok && (_response2 = response) !== null && _response2 !== void 0 && (_response2$payload = _response2.payload) !== null && _response2$payload !== void 0 && _response2$payload.id)) {
                _context.next = 14;
                break;
              }

              window.location.href = "/admin/polizas/".concat(poliza.id, "/claims/").concat(response.payload.id, "/edit");
              return _context.abrupt("return");

            case 14:
              console.error((_response3 = response) === null || _response3 === void 0 ? void 0 : _response3.payload);
              setIsSubmitting(false);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(QueryProvider, null, /*#__PURE__*/React.createElement("div", {
    className: "card cnt_claim_form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, isEdit ? "Editar Siniestro" : "Nuevo Siniestro")), /*#__PURE__*/React.createElement("div", {
    className: "card-header cardHeader"
  }, /*#__PURE__*/React.createElement(NavHeader, {
    activeStep: activeStep,
    isEdit: isEdit,
    onChangeStep: function onChangeStep(newStep) {
      return setActiveStep(newStep);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-body claimForm"
  }, activeStep === 1 && /*#__PURE__*/React.createElement(Step1, {
    loadedClaim: loadedClaim,
    poliza: poliza,
    claim: claim,
    onChangeClaim: function onChangeClaim(newClaim) {
      return setClaim(newClaim);
    }
  }), activeStep === 2 && /*#__PURE__*/React.createElement(Step2, {
    claim: claim,
    onChangeClaim: function onChangeClaim(newClaim) {
      return setClaim(newClaim);
    }
  }), activeStep === 3 && /*#__PURE__*/React.createElement(Step3, {
    claim: claim,
    onChangeClaim: function onChangeClaim(newClaim) {
      return setClaim(newClaim);
    }
  }), activeStep === 4 && isEdit && /*#__PURE__*/React.createElement(Step4, {
    claim: loadedClaim,
    onChangeClaim: function onChangeClaim(newClaim) {
      return setClaim(newClaim);
    },
    token: token
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, isEdit && /*#__PURE__*/React.createElement("a", {
    className: "btn btn-default pull-right col-md-1",
    href: "/admin/polizas/".concat(poliza.id, "/claims")
  }, "Cancelar"), /*#__PURE__*/React.createElement("button", {
    className: cx("btn pull-right col-md-2", isEdit && "btn-warning", !isEdit && "btn-success"),
    onClick: function onClick() {
      return !isSubmitting && onSubmit();
    },
    disabled: isSubmitting
  }, isSubmitting ? "Cargando..." : isEdit ? "Editar Siniestro" : "Crear Siniestro"))));
};

export default ClaimForm;